export const isSmallScreen = 768;

/*
**return {
**    "a"  : ["a a"],     param values are always returned as arrays
**    "b b": ["b"],       param names can have special chars as well
**    "c"  : ["1", "2"]   an URL param can occur multiple times!     
**    "d"  : [null]       parameters without values are set to null
**} 
*/
export function parseURLParams(url) {
    var queryStart = url.indexOf("?") + 1,
        queryEnd = url.indexOf("#") + 1 || url.length + 1,
        query = url.slice(queryStart, queryEnd - 1),
        pairs = query.replace(/\+/g, " ").split("&"),
        parms = {}, i, n, v, nv;

    if (query === url || query === "") return;

    for (i = 0; i < pairs.length; i++) {
        nv = pairs[i].split("=", 2);
        n = decodeURIComponent(nv[0]);
        v = decodeURIComponent(nv[1]);

        if (!parms.hasOwnProperty(n)) parms[n] = [];
        parms[n].push(nv.length === 2 ? v : null);
    }
    return parms;
}

export function getLocalStorage(key, defaultValue) {
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultValue
}

export function setLocalStorage(key, value = '') {
    if (value === null) return localStorage.removeItem(key)
    else return localStorage.setItem(key, JSON.stringify(value))
}
